export default "__VITE_ASSET__71c0f830__"